import '../style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { Caption } from 'views/mutual/caption';
import { FormikProps } from 'formik';
import { DisplayItemProps, useContactConfirm } from'./hooks';
import { ContactType } from'../hooks';


export type ContactConfirmProps = {
    formik: FormikProps<ContactType>;
    backPage: () => void;
  };

export const ContactConfirm = (props : ContactConfirmProps) => {
    const {displayInfo} = useContactConfirm(props.formik);

  return (
    <form onSubmit={props.formik.handleSubmit} className="contactTemplate_input_check">
        <div className="contactTemplate">
            <div className="contactTemplate_result">
                <Caption label="入力内容の確認" />
                {displayInfo.ContactDetailsType.map((lv) => (
                    <DisplayItem {...lv} />
                ))}
            </div>
      <div className="contactTemplate_button">
        <Button
          type={ButtonType.Submit}
          label={'送信する'}
          buttonFill={ButtonFill.black}
          buttonSize={ButtonSize.medium}
        />
        <Button label="前の画面に戻る" buttonFill={ButtonFill.link} buttonSize={ButtonSize.small} onClick={() => {props.backPage()}} />
      </div>
    </div>
    </form>
  );
};

const DisplayItem = (props: DisplayItemProps) => {
  const { label, value, hidden } = props;
  if (hidden) return <></>;

  return (
    <>
      <div className="displayItem">
        <div className="displayItem_header">{label}</div>   
        {value.split('\n').map((el) => (
          <div className="displayItem_body">    
          {el}
          </div>
          ))}
        </div>
    </>
  );
};
